import { Component } from "react"
import PropTypes from "prop-types"
import { IconButton } from "@mui/material"
import { FirstPage, LastPage, KeyboardArrowLeft, KeyboardArrowRight } from "@mui/icons-material"

class Arrows extends Component {
  static propTypes = {
    onPageChange: PropTypes.func.isRequired,
    page: PropTypes.number.isRequired,
    count: PropTypes.number.isRequired,
    rowsPerPage: PropTypes.number.isRequired,
  }

  handleFirstPageButtonClick = () => {
    const { onPageChange } = this.props
    onPageChange(0)
  }

  handleBackButtonClick = () => {
    const { onPageChange, page } = this.props
    onPageChange(page - 1)
  }

  handleNextButtonClick = () => {
    const { onPageChange, page } = this.props
    onPageChange(page + 1)
  }

  handleLastPageButtonClick = () => {
    const { onPageChange, count, rowsPerPage } = this.props
    onPageChange(Math.max(0, Math.ceil(count / rowsPerPage) - 1))
  }

  render() {
    const { page, count, rowsPerPage } = this.props
    return <div className="pagination-arrows">
      <IconButton
        onClick={this.handleFirstPageButtonClick}
        disabled={page === 0}
        size="large"
      >
        <FirstPage />
      </IconButton>
      <IconButton onClick={this.handleBackButtonClick} disabled={page === 0} size="large">
        <KeyboardArrowLeft />
      </IconButton>
      <IconButton
        onClick={this.handleNextButtonClick}
        disabled={page >= Math.ceil(count / rowsPerPage) - 1}
        size="large"
      >
        <KeyboardArrowRight />
      </IconButton>
      <IconButton
        onClick={this.handleLastPageButtonClick}
        disabled={page >= Math.ceil(count / rowsPerPage) - 1}
        size="large"
      >
        <LastPage />
      </IconButton>
    </div>
  }
}

export default Arrows
